import React, { PureComponent, Fragment } from 'react'
import moment from 'moment'
import cx from 'classnames'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'


class CommonReport extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${this.getTitle()}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getTitle = () => {
    const { from, to, user } = this.props

    const date = `с ${moment(from, 'DDMMYYYY').format('DD.MM.YYYY')} по ${moment(to, 'DDMMYYYY').format('DD.MM.YYYY')}`

    return `Отчет: Посетитель ${user} ${date}`
  }

  getEncodeUri = () => {
    const { statistic } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ this.getTitle() ])

    rows.push([ 'Номер заказа', 'Количество посещений', 'Проверочный код', 'Тренер', 'Дата посещения' ])

    if (!statistic.length) {
      return false
    }

    statistic.forEach(({ payed, subscription, visited }, index) => {
      const { id, quota, subscriber, trainer, ts, voucher } = subscription
      const { firstName, middleName, lastName } = trainer

      const fio = `${lastName || ''} ${firstName || ''} ${middleName || ''}`

      rows.push([ id, quota, voucher, fio, moment(visited).format('DD.MM.YYYY') ])
    })

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  render() {
    const {
      titleClassName, darkClassName, buttonClassName,
      statistic, isEmpty,
    } = this.props

    return (
      <Fragment>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                Object.keys(statistic).map(({ payed, subscription, visited }, index) => {
                  const { id, quota, subscriber, trainer, ts, voucher } = subscription
                  const { firstName, middleName, lastName } = trainer

                  return (
                    <Fragment key={id}>
                      {
                        Boolean(!index) && (
                          <Grid className={darkClassName} columns={5} gutter="md">
                            <Cell size={1}>
                              Номер заказа
                            </Cell>
                            <Cell size={1}>
                              Количество посещений
                            </Cell>
                            <Cell size={1}>
                              Проверочный код
                            </Cell>
                            <Cell size={1}>
                              Тренер
                            </Cell>
                            <Cell size={1}>
                              Дата посещения
                            </Cell>
                          </Grid>
                        )
                      }

                      <Grid className={cx({ [darkClassName]: index % 2 !== 0 })} columns={5} gutter="md">
                        <Cell size={1}>
                          {id}
                        </Cell>
                        <Cell size={1}>
                          {quota}
                        </Cell>
                        <Cell size={1}>
                          {voucher}
                        </Cell>
                        <Cell size={1}>
                          {lastName} {firstName} {middleName}
                        </Cell>
                        <Cell size={1}>
                          {moment(visited).format('DD.MM.YYYY')}
                        </Cell>
                      </Grid>
                    </Fragment>
                  )
                })
              }
              <Box pt="md">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </Fragment>
    )
  }
}


export default CommonReport
